export default '1.4.12';



// WEBPACK FOOTER //
// ./src/version.js